module.exports = __webpack_public_path__ + "static/media/vail-10.390e3b26.jpg";